
export const specialtiesListActions = {

  FETCH_SPECIALTIES_FAILED: 'FETCH_SPECIALTIES_FAILED',
  FETCH_SPECIALTIES_SUCCESS: 'FETCH_SPECIALTIES_SUCCESS',
  FETCH_SPECIALTIES_PENDING: 'FETCH_SPECIALTIES_PENDING',
  LOAD_SPECIALTIES: 'LOAD_SPECIALTIES',

  fetchSpecialtiesFailed: error => ({
    type: specialtiesListActions.FETCH_SPECIALTIES_FAILED,
    payload: error
  }),

  fetchSpecialtiesSuccess: (id, {data}) => ({
    type: specialtiesListActions.FETCH_SPECIALTIES_SUCCESS,
    payload: {
      id,
      items:data,
      count:data.length
    }
  }),

  fetchSpecialtiesPending: id => ({
    type: specialtiesListActions.FETCH_SPECIALTIES_PENDING,
    payload: {
      id
    }
  }),

  loadSpecialties: (sessionId) => ({
    type: specialtiesListActions.LOAD_SPECIALTIES,
    payload: {
      id: 'specialtiesall',
      sessionId
    }
  }),
}

export const specialtiesListRequestActions = {
  failed: specialtiesListActions.fetchSpecialtiesFailed,
  success: specialtiesListActions.fetchSpecialtiesSuccess,
  pending: specialtiesListActions.fetchSpecialtiesPending
};
